// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_dt-0";